import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import Divider from 'apollo-react/components/Divider';
import IconButton from 'apollo-react/components/IconButton';
import ListItem from 'apollo-react/components/ListItem';
import ListItemText from 'apollo-react/components/ListItemText';
import Popover from 'apollo-react/components/Popover';
import ArrowDown from 'apollo-react-icons/ArrowDown';
import Menu from 'apollo-react-icons/Menu';
import React, { useState } from 'react';

import { useTranslation } from './../../../../custom-hooks/useTranslation';
import { isEditorCompactMode } from '../../../../utils/windowDimensionsUtils';

const useStyles = makeStyles({
  divider: {
    margin: '0.5rem',
  },
  actions: {
    backgroundColor: '#fff',
    marginRight: 15,
    '@media (max-width: 1200px)': {
      display: 'none',
    },
  },
  resetOverflow: {
    overflow: 'visible!important',
    minWidth: 'initial!important',
  },

  cardContent: {
    paddingTop: 8,
    maxHeight: 530,
    overflow: 'auto',
  },
});

export const ActionButtonDropdown = ({ items }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = ({ currentTarget }) => {
    setAnchorEl((prev) => (!prev ? currentTarget : null));
  };

  const filteredItems = items.filter((action) => !action.hidden);

  return (
    <>
      {isEditorCompactMode() ? (
        <IconButton aria-label={translateString('Actions Button Dropdown')} onClick={handleClick}>
          <Menu />
        </IconButton>
      ) : (
        <Button
          variant="secondary"
          onClick={handleClick}
          className={`${classes.actions} ${classes.resetOverflow}`}
          aria-label={translateString('Actions')}
        >
          {translateString('Actions')}
          <ArrowDown fontSize="extraSmall" style={{ marginLeft: 5 }} />
        </Button>
      )}
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        PaperProps={{
          style: {
            boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.08)',
            marginTop: 5,
          },
        }}
        onBackdropClick={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Card className={classes.cardContent}>
          {filteredItems.map((item, index) =>
            item.isDivider ? (
              <Divider className={classes.divider} key={`divider ${index}`} />
            ) : (
              <ListItem button key={item.text} disabled={item.disabled}>
                <ListItemText
                  onClick={() => {
                    item.onClick();
                    setAnchorEl(null);
                  }}
                  primary={item.text}
                />
              </ListItem>
            )
          )}
        </Card>
      </Popover>
    </>
  );
};

export default ActionButtonDropdown;
